<template>
  <RevDrawer :name :title>
    <template #body>
      <div
        class="bg-static-info-max rounded-lg mb-40 flex h-[168px] w-full justify-center"
      >
        <RevIllustration
          alt="''"
          class="rounded-lg"
          :height="168"
          src="/img/mobile-plan/connectivity-illustration.png"
          :width="332"
        />
      </div>

      <RevForm
        class="space-y-24"
        :initial-values
        :validate="validate()"
        @submit="handleSubmit"
      >
        <template #default="{ values, errors, hasError }">
          <div class="space-y-8">
            <div class="body-2-bold">{{ i18n(translations.subTitle) }}</div>
            <div class="heading-2">
              {{ i18n(translations.title) }}
            </div>
          </div>
          <div class="body-2 whitespace-pre-line pb-12">
            {{ i18n(translations.description) }}
          </div>

          <div class="space-y-8">
            <RevInputText
              id="email"
              v-model="values.email"
              data-cs-mask
              :error="errors.email"
              :label="i18n(translations.emailLabel)"
            />

            <FormattedMessage
              class="text-static-default-low body-2"
              :definition="translations.privacyPolicy"
              tag="p"
            >
              <template #privacyPolicy>
                <RevLink
                  target="_blank"
                  :to="currentLocale + '/legal/data-protection'"
                >
                  <span class="text-static-default-low body-2-link">
                    {{ i18n(translations.privacyPolicyLink) }}
                  </span>
                </RevLink>
              </template>
            </FormattedMessage>
          </div>

          <RevButton
            :disabled="hasError"
            full-width="always"
            :tracking="{
              zone: 'join_waitlist',
              name: selectedMobilePlan,
            }"
            type="submit"
            variant="primary"
            >{{ i18n(translations.buttonLabel) }}
          </RevButton>
        </template>
      </RevForm>
    </template>
  </RevDrawer>
</template>

<script setup lang="ts">
import FormattedMessage from '@backmarket/nuxt-module-i18n/FormattedMessage.vue'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useI18nLocale } from '@backmarket/nuxt-module-i18n/useI18nLocale'
import { useTheToast } from '@backmarket/nuxt-module-toast/useTheToast'
import { RevButton } from '@ds/components/Button'
import { RevDrawer } from '@ds/components/Drawer'
import {
  RevForm,
  makeValidate,
  matchingRegExp,
  required,
} from '@ds/components/Form'
import { RevIllustration } from '@ds/components/Illustration'
import { RevInputText } from '@ds/components/InputText'
import { RevLink } from '@ds/components/Link'
import { closeModal } from '@ds/components/ModalBase'

import { REGEXP_VALID_EMAIL } from '~/constants/regex'
import { MODAL_NAMES } from '~/scopes/product/constants'

import translations from './MobilePlanDrawer.translations'

defineProps<{
  name: string
  title: string
  selectedMobilePlan: 'BACK_MARKET_OFFERS' | 'VODAFONE_OFFERS'
}>()

const i18n = useI18n()
const { openSuccessToast } = useTheToast()
const currentLocale = useI18nLocale()

const initialValues = {
  email: '',
}

function validate() {
  return makeValidate<typeof initialValues>({
    email: [
      required(i18n(translations.required)),
      matchingRegExp(REGEXP_VALID_EMAIL, i18n(translations.invalidEmail)),
    ],
  })
}

function handleSubmit() {
  openSuccessToast({
    title: i18n(translations.toastTitle),
    content: i18n(translations.toastDescription),
  })
  closeModal(MODAL_NAMES.MOBILE_PLAN_FAKE_DOOR)
}
</script>
